import { createAction, props } from '@ngrx/store';

import {
  ICancelTicketRequest,
  ICancelTicketResponseData,
  ICMProducto,
  ICPMotivo,
  ICreateTicketRequest,
  ICreateTicketResponseData,
  ITicketActivoResponse,
  IUpdateTicketRequest,
  IUpdateTicketResponseData,
} from '../../shared/models/CambiosMercado.interface';

/**
 * * Consultar catálogo de productos y motivos
 */
export const getCPCatalogo = createAction(
    '[CambiosMercado] Get Catalogo'
);

export const successGetCPCatalogo = createAction(
    '[CambiosMercado] Get Catalogo Success',
    props<{ productos: ICMProducto[] }>()
);

export const errorGetCPCatalogo = createAction(
    '[CambiosMercado] Get Catalogo Error',
    props<{ payload: Error }>()
);

export const clearGetCPCatalogo = createAction(
    '[CambiosMercado] Clear Get Catalogo'
);

/**
 * * Consultar motivos por SKU
 */
export const getCPReasons = createAction(
    '[CambiosMercado] Get Reasons',
    props<{ sku: string | number }>()
);

export const successGetCPReasons = createAction(
    '[CambiosMercado] Get Reasons Success',
    props<{ motivos: ICPMotivo[] }>()
);

export const errorGetCPReasons = createAction(
    '[CambiosMercado] Get Reasons Error',
    props<{ payload: Error }>()
);

export const clearGetCPReasons = createAction(
    '[CambiosMercado] Clear Get Reasons'
);

/**
 * * Crear ticket de cambio de mercado
 */
export const createTicket = createAction(
    '[CambiosMercado] Create Ticket',
    props<ICreateTicketRequest>()
);

export const successCreateTicket = createAction(
    '[CambiosMercado] Create Ticket Success',
    props<ICreateTicketResponseData>()
);

export const errorCreateTicket = createAction(
    '[CambiosMercado] Create Ticket Error',
    props<{ payload: Error }>()
);

export const clearCreateTicket = createAction(
    '[CambiosMercado] Clear Create Ticket'
);

/**
 * * Cancelar ticket de cambio de mercado
 */
export const cancelTicket = createAction(
    '[CambiosMercado] Cancel Ticket',
    props<ICancelTicketRequest>()
);

export const successCancelTicket = createAction(
    '[CambiosMercado] Cancel Ticket Success',
    props<ICancelTicketResponseData>()
);

export const errorCancelTicket = createAction(
    '[CambiosMercado] Cancel Ticket Error',
    props<{ payload: Error }>()
);

export const clearCancelTicket = createAction(
    '[CambiosMercado] Clear Cancel Ticket'
);

/**
 * * Actualizar ticket de cambio de mercado
 */
export const updateTicket = createAction(
    '[CambiosMercado] Update Ticket',
    props<IUpdateTicketRequest>()
);

export const successUpdateTicket = createAction(
    '[CambiosMercado] Update Ticket Success',
    props<IUpdateTicketResponseData>()
);

export const errorUpdateTicket = createAction(
    '[CambiosMercado] Update Ticket Error',
    props<{ payload: Error }>()
);

export const clearUpdateTicket = createAction(
    '[CambiosMercado] Clear Update Ticket'
);

/**
 * * Consultar tickets activos
 */
export const getTicketActivo = createAction(
    '[CambiosMercado] Get Ticket Activo'
);

export const successGetTicketActivo = createAction(
    '[CambiosMercado] Get Ticket Activo Success',
    props<ITicketActivoResponse>()
);

export const errorGetTicketActivo = createAction(
    '[CambiosMercado] Get Ticket Activo Error',
    props<{ payload: Error }>()
);

export const clearGetTicketActivo = createAction(
    '[CambiosMercado] Clear Get Ticket Activo'
);
